// extracted by mini-css-extract-plugin
module.exports = {"section":"Solution_section__3EMJA","container":"Solution_container__1pJuC","body":"Solution_body__1juxB","content":"Solution_content__2Ts31","image":"Solution_image__1-vaX"};